module.exports = __webpack_public_path__ + "assets/logo-sii.b43889a7.svg";